<template>
  <div class="landing-page">
    <iframe
      v-if="!isLoggedIn"
      src="/jf.html"
      class="landing-iframe"
    ></iframe>
  </div>
</template>

<script setup lang="ts">
import { computed, onMounted } from 'vue'
import { useRouter } from 'vue-router'
import { useUserStore } from '@/stores/user'
import { getNavMenus } from '@/router'

const router = useRouter()
const userStore = useUserStore()

const isLoggedIn = computed(() => !!localStorage.getItem('token'))

onMounted(() => {
  if (isLoggedIn.value) {
    // 使用和登录后一样的跳转逻辑
    const userInfoStr = localStorage.getItem('userInfo')
    if (userInfoStr) {
      try {
        const userInfo = JSON.parse(userInfoStr)
        userStore.setUserInfo(userInfo)
      } catch (e) {
        console.error('解析用户信息失败')
      }
    }

    const navMenus = getNavMenus()
    let firstAvailablePath = ''
    if (navMenus.length > 0) {
      const firstMenu = navMenus[0]
      if (firstMenu && firstMenu.children && firstMenu.children.length > 0) {
        firstAvailablePath = firstMenu.children[0].path || ''
      } else if (firstMenu && firstMenu.path) {
        firstAvailablePath = firstMenu.path
      }
    }
    router.replace(firstAvailablePath || '/search')
  }
})
</script>

<style scoped>
.landing-page {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  margin: 0;
  padding: 0;
  overflow: hidden;
  background: transparent;
}

.landing-iframe {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border: none;
  display: block;
  margin: 0;
  padding: 0;
}

.logged-in-tip {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: transparent;
}

.tip-card {
  text-align: center;
  padding: 3rem;
  background: rgba(20, 20, 30, 0.65);
  backdrop-filter: blur(12px);
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 16px;
}

.tip-card h2 {
  color: #fff;
  margin-bottom: 2rem;
  font-size: 2rem;
}
</style>
